
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {TradeHistoryInfo} from './TradeHistoryInfo';
import {FieldModelTradeHistoryInfo} from './TradeHistoryInfo';

/**
 * TradeHistoryInfoByIdResponse struct
 */
class TradeHistoryInfoByIdResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!TradeHistoryInfo=} tradeHistoryRecord
   * @constructor
   */
  constructor (parent = new Response(), tradeHistoryRecord = new TradeHistoryInfo()) {
    super()
    super.copy(parent)
    this.TradeHistoryRecord = tradeHistoryRecord
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradeHistoryInfoByIdResponse}
   * @param {!TradeHistoryInfoByIdResponse} other Other struct
   * @returns {!TradeHistoryInfoByIdResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.TradeHistoryRecord != null) {
      this.TradeHistoryRecord = TradeHistoryInfo.fromObject(other.TradeHistoryRecord)
    } else {
      this.TradeHistoryRecord = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradeHistoryInfoByIdResponse}
   * @returns {!TradeHistoryInfoByIdResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradeHistoryInfoByIdResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradeHistoryInfoByIdResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradeHistoryInfoByIdResponse}
   * @param {!TradeHistoryInfoByIdResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradeHistoryInfoByIdResponse)) {
      throw new TypeError('Instance of TradeHistoryInfoByIdResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradeHistoryInfoByIdResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      TradeHistoryRecord: ((this.TradeHistoryRecord != null) ? this.TradeHistoryRecord : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradeHistoryInfoByIdResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradeHistoryInfoByIdResponse} other Object value
   * @returns {!TradeHistoryInfoByIdResponse} Created struct
   */
  static fromObject (other) {
    return new TradeHistoryInfoByIdResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradeHistoryInfoByIdResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradeHistoryInfoByIdResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradeHistoryInfoByIdResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5122
  }
}

export { TradeHistoryInfoByIdResponse };

/**
 * Fast Binary Encoding TradeHistoryInfoByIdResponse field model
 */
class FieldModelTradeHistoryInfoByIdResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.TradeHistoryRecord = new FieldModelTradeHistoryInfo(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.TradeHistoryRecord.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.TradeHistoryRecord.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradeHistoryInfoByIdResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5122
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.TradeHistoryRecord.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TradeHistoryRecord.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeHistoryRecord.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @param {!TradeHistoryInfoByIdResponse} fbeValue Default value, defaults is new TradeHistoryInfoByIdResponse()
   * @returns {!TradeHistoryInfoByIdResponse} TradeHistoryInfoByIdResponse value
   */
  get (fbeValue = new TradeHistoryInfoByIdResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @param {!TradeHistoryInfoByIdResponse} fbeValue TradeHistoryInfoByIdResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.TradeHistoryRecord.fbeSize) <= fbeStructSize) {
      fbeValue.TradeHistoryRecord = this.TradeHistoryRecord.get()
    } else {
      fbeValue.TradeHistoryRecord = new TradeHistoryInfo()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TradeHistoryRecord.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @param {!TradeHistoryInfoByIdResponse} fbeValue TradeHistoryInfoByIdResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradeHistoryInfoByIdResponse}
   * @param {TradeHistoryInfoByIdResponse} fbeValue TradeHistoryInfoByIdResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.TradeHistoryRecord.set(fbeValue.TradeHistoryRecord)
  }
}

export { FieldModelTradeHistoryInfoByIdResponse };

/**
 * Fast Binary Encoding TradeHistoryInfoByIdResponse model
 */
class TradeHistoryInfoByIdResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradeHistoryInfoByIdResponse(this.buffer, 4)
  }

  /**
   * Get the TradeHistoryInfoByIdResponse model
   * @this {!TradeHistoryInfoByIdResponseModel}
   * @returns {!FieldModelTradeHistoryInfoByIdResponse} model TradeHistoryInfoByIdResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradeHistoryInfoByIdResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradeHistoryInfoByIdResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradeHistoryInfoByIdResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradeHistoryInfoByIdResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradeHistoryInfoByIdResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradeHistoryInfoByIdResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradeHistoryInfoByIdResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradeHistoryInfoByIdResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradeHistoryInfoByIdResponseModel}
   * @param {!TradeHistoryInfoByIdResponse} value TradeHistoryInfoByIdResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradeHistoryInfoByIdResponseModel}
   * @param {!TradeHistoryInfoByIdResponse} value TradeHistoryInfoByIdResponse value, defaults is new TradeHistoryInfoByIdResponse()
   * @return {!object} Deserialized TradeHistoryInfoByIdResponse value and its size
   */
  deserialize (value = new TradeHistoryInfoByIdResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradeHistoryInfoByIdResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradeHistoryInfoByIdResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradeHistoryInfoByIdResponseModel}
   * @param {!number} prev Previous TradeHistoryInfoByIdResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradeHistoryInfoByIdResponseModel };
